import { Controller } from "@hotwired/stimulus";

const COLLAPSED_HEIGHT = "12px";

export default class extends Controller {
  static targets = ["content"];
  static values = { expanded: { type: Boolean, default: true } };

  connect() {
    this.originalHeight = this.contentTarget.style.height;
    this.setExpanded(this.expandedValue, false);
  }

  toggle() {
    this.setExpanded(!this.expandedValue, true);
  }

  setExpanded(expanded, animate) {
    this.expandedValue = expanded;
    const el = this.contentTarget;

    if (animate) {
      el.style.transition =
        "height 250ms cubic-bezier(0.25, 0.1, 0.25, 1)";
    } else {
      el.style.transition = "none";
    }

    el.querySelectorAll(".chart-row-data").forEach((child) => {
      child.style.visibility = expanded ? "" : "hidden";
    });

    if (expanded) {
      el.style.height = this.originalHeight;
      el.style.overflow = "";
      el.classList.remove("bg-fill-elevation-level-base");
      el.classList.add("bg-fill-elevation-level-1");
    } else {
      el.style.height = COLLAPSED_HEIGHT;
      el.style.overflow = "hidden";
      el.classList.remove("bg-fill-elevation-level-1");
      el.classList.add("bg-fill-elevation-level-base");
    }

    this.element
      .querySelector("[data-chevron]")
      ?.classList.toggle("rotate-90", expanded);
  }
}
